import Layout from "components/ManagerLayout"
import Card from "components/Card/Card"
import CardHeader from "components/Card/CardHeader"
import { Flex, Text, VStack } from "@chakra-ui/react"
import DataTableCard from "components/DataTableCard"
import SchedulesTable from "./SchedulesTable"
import Filters from "./Filters"
import Charts from "./Charts"

const Schedules = () => {
	return (
		<Layout>
			<VStack w="full" spacing={2}>
				<Filters />
				<Charts />
				<Card>
					<CardHeader>
						<Flex w="full" justifyContent="space-between" alignItems="center">
							<Text>Compromissos</Text>
						</Flex>
					</CardHeader>
					<DataTableCard>
						<SchedulesTable />
					</DataTableCard>
				</Card>
			</VStack>
		</Layout>
	)
}

export default Schedules